import { Injectable, inject } from '@angular/core';
import { first } from 'rxjs';

import { Platform } from '@ionic/angular/standalone';

import { SplashScreen } from '@capacitor/splash-screen';

import { AuthService } from '../auth/auth.service';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AppReloadService {
  private platform = inject(Platform);
  private authService = inject(AuthService);
  private localStorageService = inject(LocalStorageService);

  threshold = 10 * 60 * 1000;

  init(): void {
    this.platform.pause.subscribe(async () => {
      await this.localStorageService.set('reload', Date.now());
    });

    this.platform.resume.subscribe(async () => {
      const lastReload = await this.localStorageService.get('reload');
      if (Date.now() - lastReload >= this.threshold) {
        location.reload();
        await SplashScreen.show();
      } else {
        this.authService
          .getAuthenticatedUser()
          .pipe(first())
          .subscribe((user) => {
            if (user) {
              this.authService.getAndSetUnreadTotalNotifications();
            }
          });
      }
    });
  }
}
